import { useHistory, useLocation } from 'react-router-dom';

import { type LinkProps } from '@/components/ui/link';

export function useHrefFromTo(to: LinkProps['to']): string {
  const history = useHistory();
  const location = useLocation();

  if (typeof to === 'string') {
    return to;
  }

  if (typeof to === 'object') {
    return history.createHref(to);
  }

  const computedTo = to(location);

  if (typeof computedTo === 'string') {
    return computedTo;
  }

  return history.createHref(computedTo);
}
